<div [class]="classes()">
  <div class="cart-group__header">
    <div class="cart-group__label">
      <ftr-icon class="cart-group__icon" icon="Courthouse" size="Small" />
      <span>{{ group().location.parentName }}</span>
    </div>
    <div class="cart-group__label">
      <ftr-icon class="cart-group__icon" icon="Courtroom" size="Small" />
      <span>{{ group().location.name }}</span>
    </div>
    <div class="cart-group__label">
      <ftr-icon class="cart-group__icon" icon="CalendarDay" size="Small" />
      <ftr-date [date]="group().date" [format]="dateFormat.DateLong" />
    </div>
  </div>
  <div class="cart-group__items">
    @for (item of group().items; track item.id) {
      <div class="cart-group__item">
        <ng-container *ngTemplateOutlet="itemTemplate(); context: { $implicit: item }" />
      </div>
    }
  </div>
</div>
